import React from 'react';

const PrivacyPolicy: React.FC = () => (
  <div style={{ padding: 24, maxWidth: 1000, margin: '0 auto', background: '#fff', borderRadius: 8, lineHeight: 1.6 }}>
    <h1 style={{ textAlign: 'center', color: '#1890ff', marginBottom: 32 }}>达康AI医疗辅助系统隐私政策</h1>
    
    <div style={{ marginBottom: 24 }}>
      <p>
        欢迎您使用达康AI医疗辅助系统！"达康AI医疗辅助系统"是广州市达康经济发展有限公司为用户提供医疗辅助服务的智能平台，
        由广州市达康经济发展有限公司（注册地址：广州市黄埔区茅岗东路343号（厂内自编19栋），以下简称"达康公司"或"我们"）运营。
        我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：
        权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。
      </p>
      <p>
        本隐私政策（以下简称"本政策"）与您使用我们的产品或服务息息相关，我们将按照本政策收集、使用、保存、共享和保护您的个人信息，
        请您在使用前仔细阅读并确认您已经充分理解和同意本政策，尤其是<strong>黑色加粗的内容</strong>。
        一旦您使用或者继续使用达康AI医疗辅助系统的产品及/或服务时，即意味着您同意按照本政策处理您的相关信息。
      </p>
    </div>

    <h2>一、定义及适用范围</h2>
    <h3>（一）定义</h3>
    <ul>
      <li><strong>我们</strong>：是指达康AI医疗辅助系统，即达康公司为用户提供医疗辅助服务的官方服务平台。</li>
      <li><strong>关联公司</strong>：达康公司股东公司广汽本田汽车有限公司、东风本田发动机有限公司，或用户所属公司。</li>
      <li><strong>个人信息</strong>：指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息。个人信息包括但不限于姓名、出生日期、证件号码、个人生物识别信息、住址、通信通讯联系方式、通信记录和内容、账号密码、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息等。</li>
      <li><strong>敏感个人信息</strong>：指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。敏感个人信息包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</li>
    </ul>

    <h3>（二）适用范围</h3>
    <p>
      本政策适用于达康AI医疗辅助系统向您提供的各项产品和服务。如关联公司在其产品或服务中使用了我们的产品或服务，
      但未设置独立隐私政策的，则本政策同样适用于该部分产品或服务。
    </p>

    <h2>二、我们收集、使用个人信息的目的及范围</h2>
    <p>为符合国家法律法规规定和实现本政策所述的下述业务功能，我们会在遵循合法、正当、必要原则的前提下，收集和使用您在使用我们的服务过程中主动提供和因使用我们的服务而产生或需向第三方收集的下述个人信息。</p>

    <h3>1. 账号注册与登录</h3>
    <p>
      当您选择注册达康AI医疗辅助系统账号时，您需要主动向我们提供您本人设置的账号、手机号、口令、验证码、昵称、头像。
      前述信息为必要信息，如果您不提供，您将无法完成注册。
    </p>

    <h3>2. 身份识别与实名认证</h3>
    <p>
      为了识别您的身份，以及履行国家法律法规规定的实名认证义务，您需要向我们提供您的手机号、验证码、姓名、性别、证件类型、证件号码、证件有效期、证件照片。
      前述信息为进行身份认证的必要信息，如果您不提供，您将可能无法完成身份认证。
    </p>

    <h3>3. 医疗辅助服务</h3>
    <p>
      当您使用我们的医疗辅助服务时，我们需要收集您的健康信息、症状描述、病史记录、用药情况等医疗相关信息，
      以便为您提供准确的医疗辅助建议和服务。
    </p>

    <h3>4. 交易安全保障</h3>
    <p>
      为了准确识别、预防攻击和保护您的账户和交易安全，在您使用产品的过程中，我们将自动收集部分设备信息或软件信息，
      具体包括：用户的IP地址、移动设备所用的型号/版本/存储空间和设备识别码、SIM卡信息、设备应用安装/卸载列表、
      进程信息、设备MAC地址、网络类型/网络状态等。
    </p>

    <h2>三、我们如何收集您的个人信息</h2>
    <p>我们会通过如下渠道收集您的个人信息：</p>
    <ul>
      <li><strong>您直接提供的信息</strong>：我们可能会收集您在达康AI医疗辅助系统注册账号、申请或使用我们的服务时填写的信息。</li>
      <li><strong>我们主动收集的信息</strong>：我们会通过Cookie等自动收集工具收集您的设备信息以及与我们的服务相关的日志信息。</li>
      <li><strong>从第三方取得您的信息</strong>：在取得您单独同意的前提下，我们还可能从依法设立并合法留存您相关信息的第三方获取您的特定信息。</li>
    </ul>

    <h2>四、我们如何使用Cookie和同类技术</h2>
    <p>
      为了确保达康AI医疗辅助系统的正常运转，我们会在您移动设备上存储名为Cookie的小数据文件或类似文件。
      Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，达康AI医疗辅助系统能够存储您的偏好数据。
    </p>

    <h2>五、我们如何委托处理、共享、转让、公开披露个人信息</h2>
    <h3>1. 委托处理</h3>
    <p>除非另有明确说明，我们未委托第三方公司、组织或个人处理您的个人信息。</p>

    <h3>2. 共享</h3>
    <p>我们不会与任何公司、组织或个人分享您的个人信息，但以下情况除外：</p>
    <ul>
      <li>事先获得您的明确同意的；</li>
      <li>根据法律法规规定，或者政府主管部门、司法机关的强制要求必须对外共享的；</li>
      <li>为了实现本政策所述的某些业务功能和目的，我们可能会与特定的合作伙伴共享您的一些个人信息。</li>
    </ul>

    <h2>六、我们如何存储您的个人信息</h2>
    <h3>1. 存储地域与跨境传输</h3>
    <p>
      您的所有个人信息将储存于中华人民共和国境内，本隐私政策项下，您的个人信息不涉及跨境传输。
      若将来涉及跨境传输且确需向境外机构传输您的个人信息，我们会按照法律、行政法规和相关监管部门的规定执行。
    </p>

    <h3>2. 存储期限</h3>
    <p>
      除法律、行政法规另有规定外，我们仅会在为实现处理目的所必要的最短时间内保存您的个人信息。
      超出前述保存期限后，我们会对您的个人信息进行删除或匿名化处理。
    </p>

    <h2>七、我们如何保护您的个人信息</h2>
    <p>我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止您的个人信息遭到未经授权访问、使用、修改、公开披露、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息，比如：</p>
    <ul>
      <li>我们与所有可能接触个人信息的员工签订了保密协议，对关键岗位人员进行背景审查，并建立了严格的访问权限控制、权限审批流程和监控、审计机制；</li>
      <li>我们与所有可能接触用户个人信息的合作伙伴均签署了严格的保密协议或数据保护专用条款；</li>
      <li>我们采用行业标准的加密技术保护您的医疗健康信息等敏感数据。</li>
    </ul>

    <h2>八、您的权利</h2>
    <p>根据国家相关法律、法规、标准，我们保障您对自己的个人信息行使以下权利：</p>
    <ul>
      <li><strong>访问您的个人信息</strong>：您有权通过达康AI医疗辅助系统设置的各项功能界面访问您的个人信息。</li>
      <li><strong>更正您的个人信息</strong>：当您发现我们处理的您的个人信息有误时，您可以通过系统设置进行修改或更正。</li>
      <li><strong>删除您的个人信息</strong>：在特定情形下，您可以向我们提出删除个人信息的请求。</li>
      <li><strong>注销您的账号</strong>：在您确认不再使用我们的服务时，您可以申请注销账号。</li>
    </ul>

    <h2>九、我们如何处理未成年人的个人信息</h2>
    <p>
      按照中华人民共和国相关法律规定，未满18周岁为未成年人，不满14周岁的未成年人为儿童。
      达康AI医疗辅助系统主要面向成年人，如没有父母或监护人同意的，未成年人，尤其是未满14周岁儿童不应创建自己的个人信息主体账户。
    </p>

    <h2>十、本政策如何更新</h2>
    <p>
      我们的隐私政策可能变更。未经您明确同意，我们不会削减您在本政策项下应享有的权利。
      我们会在本页面上发布对本政策所作的任何变更。对于重大变更，我们还会提供更为显著的通知。
    </p>
  </div>
);

export default PrivacyPolicy; 